import { useContext } from 'react'

import { Tooltip } from '@mui/material'

import { NegativateStatus } from 'utils/enums'

import { NegativationContext } from '../../context'
import { getHoverText, renderTitle } from '../utils'
import { Status, Wrapper } from './Header.styles'

const Header = () => {
  const { negativation } = useContext(NegativationContext)
  return (
    <Wrapper>
      <div>{renderTitle('Detalhes da negativação', 'settings', true)}</div>
      <Tooltip arrow title={getHoverText(negativation.status).text}>
        <div>
          <Status
            status={negativation?.status || 'pending'}
            sx={{ textAlign: 'center', width: 'max-content' }}
          >
            {NegativateStatus[negativation?.status || 'pending']}
          </Status>
        </div>
      </Tooltip>
    </Wrapper>
  )
}

export default Header
